import { motion } from "motion/react";

/**
 * 品牌標誌
 * ---------------------------------------------------------------
 * 照設計稿的組合：斜體粗字 + 前後兩段不同顏色 + 底下一條漸層底線。
 *
 * 底線是關鍵細節 —— 它讓 logo 不只是一段文字，而是一個「有結構的標誌」。
 * hover 時底線會從左往右重畫一次，這是全站「網站是活的」的第一個訊號。
 */
export default function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <motion.span initial="rest" whileHover="hover" className="inline-flex flex-col select-none">
      <span className="text-2xl font-bold italic tracking-tight leading-none">
        <span className="text-ink">Coloure</span>
        <span className="text-brand-800 dark:text-brand-400">Dev</span>
      </span>

      {!compact && (
        <span className="relative mt-1.5 h-[3px] w-full overflow-hidden rounded-pill bg-line">
          <motion.span
            className="absolute inset-y-0 left-0 rounded-pill"
            style={{
              background:
                "linear-gradient(90deg, var(--color-ink-muted), var(--color-brand-500))",
            }}
            variants={{
              rest: { width: "100%" },
              hover: {
                width: ["0%", "100%"],
                transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
              },
            }}
          />
        </span>
      )}
    </motion.span>
  );
}
